import { IDefaultAvailabilityType } from "../../../@types/default-availability.type"
import { Api } from "../ApiConfig"
import { ApiException } from "../ApiException"
import { getErrorMessage } from "../../../utils/utils"

export const getDefaultAvailabilityById = async (id: string) => {
    try {
        const { data } = await Api.get(`api/DefaultAvailability/GetDefaultAvailabilityById?id=${id}`)
        return data.result
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao buscar a disponibilidade padrão'))
    }
    
}

export const addOrUpdateDefaultAvailability = async (defaultAvailabilityDto: IDefaultAvailabilityType) => { 
    try {
        const { data } = await Api.post(`api/DefaultAvailability/AddOrUpdateDefaultAvailability`, defaultAvailabilityDto)
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao criar Disponibilidade Padrão'))
    }
}